import React, { useEffect } from 'react';
import HeaderBottom from '../components/HomePage/HeaderBottom';

const PrivacyPolicyPage = () => {
  useEffect(() => {
    // Scroll to the top when page loads
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="boxed_wrapper ltr">
      <HeaderBottom />

      {/* Page Title Section */}
      <section 
        className="page-title centred p_relative" 
        style={{ backgroundImage: "url(assets/images/background/page-title.jpg)" }}
      >
        <div className="auto-container">
          <div className="content-box">
            <h1>Privacy Policy</h1>
            <ul className="bread-crumb clearfix">
              <li><a href="/">Home</a></li>
              <li>Privacy Policy</li>
            </ul>
          </div>
        </div>
      </section>

      {/* Privacy Policy Container */}
      <section className="privacy-policy-section pb_120 pt_120 bg-color-1">
        <div className="auto-container">
          <div 
            className="privacy-content-wrapper" 
            style={{ 
              background: '#ffffff', 
              padding: '30px', 
              borderRadius: '20px',
              boxShadow: '0 15px 35px rgba(0, 0, 0, 0.04)',
              minHeight: '800px',
              border: '1px solid rgba(0, 0, 0, 0.05)',
              overflow: 'hidden'
            }}
          >
            {/* Same-origin Iframe to render local HTML policy file securely */}
            <iframe 
              src="/privacy-policy-embed.html" 
              style={{ width: '100%', border: 'none', minHeight: '800px' }}
              title="Privacy Policy"
            ></iframe>
          </div>
        </div>
      </section>
    </div>
  );
};

export default PrivacyPolicyPage;
